const setTicketIds = val => {
  return { type: 'CONTINUE_SHOPPING_MODAL_SET_TICKET_IDS', val };
}

/**
 * Store in state that all of the currently carted items
 * have been displayed by the continue shopping modal
 */
export const updateDisplayedItems = () => {
  return async (dispatch, getState) => {
    const state = getState();
    // update ticket ids
    dispatch(setTicketIds(
      [
        ...new Set(
          [
            ...state.tickets.tickets.map(ticket => +ticket.id),
            ...[...state.continueShoppingModal.displayedTicketIds]
          ]
        )
      ]
    ));
  }
}
